<template>
	<v-speed-dial
		v-model="fab"
		class="speed-dial"
		direction="top"
		transition="slide-y-reverse-transition"
		z-index="99"
		fixed
		bottom
		right
	>
		<v-btn slot="activator" v-model="fab" v-blur fab>
			<v-icon
				class="speed-dial--activator"
				:class="{ active: fab }"
				color="rust-red"
				>fa-plus</v-icon
			>
		</v-btn>

		<v-list elevation="1" class="fab-list">
			<v-list-item @click="$emit('select', 'register')">
				<v-list-item-title v-text="strings.lock" />
			</v-list-item>

			<v-list-item @click="$emit('select', 'users')">
				<v-list-item-title v-text="strings.users" />
			</v-list-item>
		</v-list>
	</v-speed-dial>
</template>

<style lang="scss" scoped>
.speed-dial {
	.speed-dial--activator {
		transition: transform 150ms ease;

		&.active {
			transform: rotate(135deg);
		}
	}

	::v-deep.v-speed-dial__list {
		right: 0;
		left: unset;
		width: fit-content;

		.v-list-item {
			height: 40px;
		}
	}
}
</style>

<script>
import strings from "@/utils/strings";

export default {

	data: () => ({
		strings: strings.lock.add,

		// Showing fab speed-dial
		fab: false,
	}),
};
</script>
